var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-header'),_vm._v(" "),_c('FirstSwiper'),_vm._v(" "),_c('Class'),_vm._v(" "),_c('Salarylist'),_vm._v(" "),_c('Teacher'),_vm._v(" "),(!_vm.isMiniProgram)?_c('SquareVideo'):_vm._e(),_vm._v(" "),_c('Hot'),_vm._v(" "),_c('Problem'),_vm._v(" "),_c('Campus')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b78db5e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Index.vue
// module id = null
// module chunks = 